
import { backgroundToTextColor } from '@klv/shared/styles/utils';
import { generateClassName, getColorVariantFromBackground, hasImage } from '@klv/shared/utils/functions';
import { designSystemColors } from '@klv/shared/styles/colors';
import Buttons from '@klv/molecules/buttons';
import Image from '@klv/atoms/image';

import * as s from './styles/ctaStatement.module.scss';

import type { ICtaStatement } from './types';

const CtaStatement = ({
  background = 'dark',
  buttons,
  disclaimer = '',
  headline = '',
  flagColor = 'lavender',
  image = { altText: '' },
  ...rest
}: ICtaStatement) => {
  const includesImage = hasImage(image);
  const removeOverlapGrid = flagColor === 'transparent' && includesImage === true;
  const colorVariant = getColorVariantFromBackground(background);
  const buttonColor = colorVariant;

  return (
    <div
      style={{
        '--flag-color': designSystemColors[flagColor],
        '--flag-text-color': backgroundToTextColor[flagColor],
      } as React.CSSProperties}
      className={
        generateClassName([
          s.ctaStatement,
          s[background],
          'defaultPaddingTop',
          'defaultPaddingBottom',
        ])
      }
      {...rest}
    >
      <div className={generateClassName([s.ctaStatementGrid, 'grid'])}>
        <div className={generateClassName([s.contentContainer, removeOverlapGrid && s.removeOverlapGrid])}>
          {headline && (
            <h2
              className="display2"
              dangerouslySetInnerHTML={{ __html: headline }}
            />
          )}
          {buttons !== undefined && (
            <Buttons
              className={s.buttons}
              buttons={buttons}
              buttonColor={buttonColor}
              variants={['ghost']}
            />
          )}
        </div>
        {includesImage && image?.gatsbyImage && (
          <Image
            className={s.primaryImage}
            altText={image.altText}
            imageData={image.gatsbyImage}
            layout="constrained"
          />
        )}
        {disclaimer && (
          <div
            className={
              generateClassName([
                s.disclaimer,
                buttons !== undefined && s.afterButton,
                includesImage && s.hasImage,
                "disclaimer",
              ])
            }
            dangerouslySetInnerHTML={{ __html: disclaimer }}
          />
        )}
      </div>
    </div>
  );
};

export default CtaStatement;
